import Firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/storage';
import axios from 'axios';
import {store} from "./store.js";

// Initialize Firebase

import { firebaseConfig } from '../apiKey.js';
Firebase.initializeApp(firebaseConfig());
//import { isPaymentAdmin } from '../apiKey.js';

const auth = Firebase.auth();

Firebase.auth().useDeviceLanguage();


var paymentAdminList=["7rGQI8CmvKh4CxvNa7CuSvovw7V2","AxDC6GjRg7bsl0ItO7WkL0Jdg4s1","JzZXMHJOdUPNPrePG8FE7BuxTEJ3"];
var routeAdminList=["AxDC6GjRg7bsl0ItO7WkL0Jdg4s1","JGg29bzueGfyDTJPqT1rMmPssMW2","JzZXMHJOdUPNPrePG8FE7BuxTEJ3"];
var moderatorAdminList=["AxDC6GjRg7bsl0ItO7WkL0Jdg4s1","JGg29bzueGfyDTJPqT1rMmPssMW2","VcYDC1RD93Xvwjm1gw8HVlSrsRU2","JzZXMHJOdUPNPrePG8FE7BuxTEJ3"];

function IsPaymentAdmin(id){
  for (var i in paymentAdminList) {
       if (paymentAdminList[i]==id) return true;
  }
  return false;
}

function IsRouteAdmin(id){
  for (var i in routeAdminList) {
       if (routeAdminList[i]==id) return true;
  }
  return false;
}

function IsModeratorAdmin(id){
  for (var i in moderatorAdminList) {
       if (moderatorAdminList[i]==id) return true;
  }
  return false;
}

function GetCommentsByRouteId(routeId){
  return new Promise(function(resolve, reject) {  
    let ref = Firebase.database().ref('ggComment').orderByChild('hikeId').equalTo(routeId);   
    ref.once('value').then(snap => {
      const keys = [];
      const data = [];    
      snap.forEach(ss => {
         data.push(ss.val());
         keys.push(ss.key);
      });
      resolve(data);             
    }).catch(e => {
      reject(e);       
      console.log(e);    
    })  
  })
}

function GetCommentsByStatus(status){
  return new Promise(function(resolve, reject) {  
    let ref = Firebase.database().ref('ggComment').orderByChild('status').equalTo(status);   
    ref.once('value').then(snap => {
      const keys = [];
      const data = [];    
      snap.forEach(ss => {
         data.push(ss.val());
         keys.push(ss.key);
      });
      resolve(data);             
    }).catch(e => {
      reject(e);       
      console.log(e);    
    })  
  })
}

function GetCertifyByDate(date1,date2){
  return new Promise(function(resolve, reject) {  
    let ref = Firebase.database().ref('ggCertify').orderByChild('enddate'); 
    ref = ref.startAt(date1).endAt(date2);   
    ref.once('value').then(snap => {
      const keys = [];
      const data = [];    
      snap.forEach(ss => {
         data.push(ss.val());
         keys.push(ss.key);
      });
      resolve(data);             
    }).catch(e => {
      reject(e);       
      console.log(e);    
    })  
  })
}

function GetCertifyByStatus(status){
  return new Promise(function(resolve, reject) {  
    let ref = Firebase.database().ref('ggCertify').orderByChild('status').equalTo(status); 
    ref.once('value').then(snap => {
      const keys = [];
      const data = [];      
      snap.forEach(ss => {
         data.push(ss.val());
         keys.push(ss.key);
      });
      resolve(data);             
    }).catch(e => {
      reject(e);       
      console.log(e);    
    })  
  })
}

function GetCertifyByRouteId(rid){
  return new Promise(function(resolve, reject) {  
    let ref = Firebase.database().ref('ggCertify').orderByChild('hikeId').equalTo(rid); 
    ref.once('value').then(snap => {
      const keys = [];
      const data = [];      
      snap.forEach(ss => {
         data.push(ss.val());
         keys.push(ss.key);
      });
      resolve(data);             
    }).catch(e => {
      reject(e);       
      console.log(e);    
    })  
  })
}

function UpdateUserName(uid,newName){
  var updates = {};    
  var url1= 'https://csavar-go.firebaseio.com/ggCertify.json?orderBy="userId"&equalTo="'+uid+'"';     
  return new Promise(function(resolve, reject) {  
      axios.get(url1)
      .then(response => {          
        for (var i in response.data) {
          updates['/ggCertify/' + i + '/userName'] = newName;
        }
        Firebase.database().ref().update(updates).then(res=>{
          resolve(true);
        })
        .catch(e => {
          reject(e);           
        })  
      }).catch(e => {
        reject(e);           
      })  
  }); 
}

function updatePwd(newPwd){
  return new Promise(function(resolve, reject) {
    Firebase.auth().currentUser.updatePassword(newPwd).then(()=> {
      resolve(true);
    }).catch(e=>{
      reject(e)
    })
  })
}

function SetPPandNL(uid){
  return new Promise(function(resolve, reject) {
    var updates = {}; 
    updates['/ggUser/' + uid + '/privacypolicy'] = 1; 
    updates['/ggUser/' + uid + '/newsletter'] = false;   
    Firebase.database().ref().update(updates).then(res=>{
      resolve(true);
    })
    .catch(e => {
      reject(e);           
    }) 
  });
}

function UpdateUserOther(nl,uid){
  return new Promise(function(resolve, reject) {
    var updates = {}; 
    updates['/ggUser/' + uid + '/newsletter'] = nl;   
    Firebase.database().ref().update(updates).then(res=>{
      resolve(true);
    })
    .catch(e => {
      reject(e);           
    }) 
  });
}

function updateProfile(newProfile,isChangeName){
  return new Promise(function(resolve, reject) {
    Firebase.auth().currentUser.updateProfile({
      displayName: newProfile.name,
      photoURL: newProfile.photoUrl
    }).then(function() {
      var updates = {}; 
      if (newProfile.name) updates['/ggUser/' + newProfile.uid + '/name'] = newProfile.name; 
      if (newProfile.publicName) updates['/ggUser/' + newProfile.uid + '/publicName'] = newProfile.publicName;       
      if (newProfile.gender) updates['/ggUser/' + newProfile.uid + '/gender'] = newProfile.gender;      
      if (newProfile.yearOfBirth) updates['/ggUser/' + newProfile.uid + '/yearOfBirth'] = newProfile.yearOfBirth;  
      Firebase.database().ref().update(updates).then(res=>{
        if (isChangeName) {
          UpdateUserName(newProfile.uid,newProfile.name).then(res=>{
            resolve(true);
          }).catch(e=>{
            reject(e);
          }) 
        } else {
          resolve(true);
        }
      })
      .catch(e => {
        reject(e);           
      })  
    }).catch(e=> {
      reject(e);
    });
  });
}

function GetUserData(userId){  
  return new Promise(function(resolve, reject) {  
    var ref = Firebase.database().ref('ggUser/'+userId);
    ref.once("value", function(snapshot) {
      resolve(snapshot.val())
    }, function (errorObject) {
      reject(e);
    });
  });
}

function googleSignIn() {
  const provider = new Firebase.auth.GoogleAuthProvider(); // Google Auth Provider inicializálása
  return new Promise((resolve, reject) => {
    Firebase.auth()
      .signInWithPopup(provider) // Popup alapú Google bejelentkezés
      .then((result) => {
        console.log("Google bejelentkezés sikeres:", result.user);
        resolve(result.user); // Visszaadja a bejelentkezett felhasználót
      })
      .catch((error) => {
        console.error("Google bejelentkezési hiba:", error.message);
        reject(error);
      });
  });
}

var providerF = new Firebase.auth.FacebookAuthProvider();
function facebookSignIn() {
  return new Promise(function(resolve, reject) {
    Firebase.auth()  
    .signInWithRedirect(providerF).then(function(result) {
          resolve(true);
    }).catch(function(error) {
        reject(new Error(error));
    });    
  });
}

function passwordSignIn(loginData) {
  return new Promise(function(resolve, reject) {
    Firebase.auth()  
    .signInWithEmailAndPassword(loginData.email, loginData.password).then(function(result) {
        if (result.user.emailVerified) resolve(true);
        else {
            SignOut().then(res=>{
                var error={};
                error.message='Az email cím hitelesítése még nem történt meg!';
                reject(error);    
            }).catch(err=>{
                reject(err);
            });               
        }
    }).catch(function(error) {
        reject(error);
    });    
  });
}

async function SignIn(mod, loginData) {
  switch (mod) {
    case "password":
      return await passwordSignIn(loginData);
    case "google":
      return await googleSignIn();
    case "facebook":
      return await facebookSignIn();
    default:
      throw new Error("Érvénytelen bejelentkezési mód!");
  }
}

function SignUp(regData){
    return new Promise(function(resolve, reject) {
      Firebase.auth().createUserWithEmailAndPassword(regData.email, regData.password).then(user => {                                  
            Firebase.auth().currentUser.updateProfile({
                displayName: regData.displayName,
                photoURL: ""
            }).then(function() {
                Firebase.auth().currentUser.sendEmailVerification().then(function() {                    
                    SignOut().then(res=>{
                        resolve(res);                         
                    }).catch(err=>{
                        reject(err);
                    });                             
                }, function(error) {
                    reject(err);
                });                          
            }).catch(function(error) {
                reject(err);
            });               
      }).catch(err => {
        reject(err);
      })
    });
  }

function PasswordReset(email) {
    return new Promise(function(resolve, reject) {
        Firebase.auth()  
        .sendPasswordResetEmail(email).then(function(result) {
            resolve(true);
        }).catch(function(error) {
            reject(error);
        });    
    });
}

function SignOut() {
    return new Promise(function(resolve, reject) {
      Firebase.auth().signOut()
      .then(function() {
        store.commit('setLogoutUser',false);    
        resolve(true);
      }, function(error) {
        reject(new Error(error)); 
      });
    });
}

function GetGeogo(gid) {
    var url = 'https://csavar-go.firebaseio.com/ggHike/'+gid+'.json';
    return new Promise(function(resolve, reject) {  
        axios.get(url)
        .then(response => {            
          resolve(response.data);
        })
        .catch(e => {
          reject(e);           
        }) 
    });
}

function GetGeogoList() {
    //Csak a publikált túrákat adja vissza.
    var url='https://csavar-go.firebaseio.com/ggHike.json?orderBy="status"&equalTo=2';
    return new Promise(function(resolve, reject) {  
        axios.get(url)
        .then(response => { 
          resolve(response.data);
        })
        .catch(e => {
          reject(e);           
        })  
    });
}

function GetAllGeogoToAdmin() {
  var url = 'https://csavar-go.firebaseio.com/ggHike.json';
  return new Promise(function(resolve, reject) {  
      axios.get(url)
      .then(response => {            
        resolve(response.data);
      })
      .catch(e => {
        reject(e);           
      })  
  });
}


function UpdateCertify(cert,del=false){  
  return new Promise(function(resolve, reject) { 
      var updates = {};
      if (del) updates['/ggCertify/' + cert.id] = null;
      else updates['/ggCertify/' + cert.id] = cert;
      Firebase.database().ref().update(updates).then(res=>{
        resolve(true);
      })
      .catch(e => {
        reject(e);           
      }) 
  })
}

function UpdateHike(hike){
  var updates = {};  
  var newId=null;
  if (!hike.id) {
      newId = Firebase.database().ref().child('ggHike').push().key;
      hike.id=newId;
  }
  updates['/ggHike/' + hike.id] = hike;
  return new Promise(function(resolve, reject) { 
      Firebase.database().ref().update(updates).then(res=>{
        resolve(hike);
      }).catch(e => {
        reject(e);           
      }) 
    })
}

function UpdateComment(comment){
  var updates = {};  
  var newId=null;
  if (!comment.id) {
      newId = Firebase.database().ref().child('ggComment').push().key;
      comment.id=newId;
  }
  updates['/ggComment/' + comment.id] = comment;
  return new Promise(function(resolve, reject) { 
      Firebase.database().ref().update(updates).then(res=>{
        resolve(comment);
      }).catch(e => {
        reject(e);           
      }) 
    })
}

var userList=[];

function GetUserDataByEmail(email){  
    return new Promise(function(resolve, reject) {  
      var ref = Firebase.database().ref('ggUser');
      ref.orderByChild('email')
      .equalTo(email)
      .once('value')
      .then(function (snapshot) {
        var value = snapshot.val();
        if (value) {
          var id = Object.keys(value)[0];
          userList.push(value[id]);
        } else {
          console.log('Ez az e-mail (',email,') cím nem létezik');
        }
        resolve(true);
      })
      .catch((e) => {
        reject(e);
      });
    });
}  

function CertifyOneShare(cert){
  var certifyRef = Firebase.database().ref('ggCertify/');
  var newCertifyRef = certifyRef.push();
  var id = newCertifyRef.key;
  cert.id=id;
  return new Promise(function(resolve, reject) {  
    UpdateCertify(cert)
    .then(response => { 
      resolve(true);              
    })
    .catch(e => {
      reject(e);           
    })   
  })  
}

function UpdatePoints(pointList,hike){    
    var updates = {};
    for (var p in pointList) {
        if (!pointList[p].id) {
            var newId = Firebase.database().ref().child('ggPoint').push().key;
            pointList[p].id=newId;
        }
        updates['/ggPoint/' + pointList[p].id] = pointList[p];        
    }    
    updates['/ggHike/' + hike.id] = hike; //A középpont (lon,lat) módosítása miatt        
    return new Promise(function(resolve, reject) { 
      Firebase.database().ref().update(updates).then(res=>{
        resolve(pointList);
      })
      .catch(e => {
        reject(e);           
      }) 
    })
}

function DeletePoint(point){
    var refPath='ggPoint/'+point.id+'/';
    return new Promise(function(resolve, reject) {  
        Firebase.database().ref(refPath).remove().then(res=>{          
            resolve("Sikeres művelet");
          })
          .catch(e => {
            reject(e);           
          })              
    });
}

function DeleteComment(commentId){
  var refPath='ggComment/'+commentId;
  return new Promise(function(resolve, reject) {  
      Firebase.database().ref(refPath).remove().then(res=>{          
          resolve(true);
        })
        .catch(e => {
          reject(e);           
        })              
  });
}

function AddToFavorite2(item, user) {
  return new Promise(function(resolve, reject) {  
      GetPoints(item.id).then(res=>{
          var pl= "{";
          for (var p in res.points) {
              pl=pl+'"'+p+'":"0",';
          }            
          pl=pl.substring(0, pl.length-1)+"}";
          var pointList = JSON.parse(pl);
          var certifyRef = Firebase.database().ref('ggCertify/');
          var newCertifyRef = certifyRef.push();
          var id = newCertifyRef.key;
          var newData={
              "id": id,
              "hikeId": item.id,
              "hikeName": item.name,
              "distance": item.distance,
              "userId": user.uid,
              "userName": user.publicName,
              "dipName": user.name,
              "userGender": user.gender,
              "startdate": "",
              "enddate": "",
              "ggpoint": 0,
              "rating": 0,
              "sumtime": 0,
              "status": 0,
              "points":pointList,
              "mode":""
          };    
          newCertifyRef.set(newData, function(error) {
              if (error) {
                reject(error);
              } else {
                resolve(newData);            
              }
          });    
      }).catch(e => {
        reject(e);           
      })  
  });
}

function GetPoints2(hid){
  var url= 'https://csavar-go.firebaseio.com/ggPoint.json?&orderBy="hikeId"&equalTo="'+hid+'"';
  return new Promise(function(resolve, reject) {  
      axios.get(url)
      .then(response => {     
        resolve(response.data);
      })
      .catch(e => {
        reject(e);           
      })  
  });
}

function GetPoints(hid){
    var url= 'https://csavar-go.firebaseio.com/ggPoint.json?&orderBy="hikeId"&equalTo="'+hid+'"';
    return new Promise(function(resolve, reject) {  
        axios.get(url)
        .then(response => {     
          var res=response.data;         
          var markers=[];
          Object.keys(res).map(function(objectKey, index) {
              var value = res[objectKey];
              var marker = { "position": { "lng": value.lat, "lat": value.lon }, "visible": true,  "text": value.name, "allPointInfo":value };        
              markers.push(marker);
          });              
          var response={};
          response.points=res;
          response.markers=markers;
          resolve(response);
        })
        .catch(e => {
          reject(e);           
        })  
    });
}

function GetHikeCertifyesCount(hid){
  var url= 'https://csavar-go.firebaseio.com/ggCertify.json?orderBy="hikeId"&equalTo="'+hid+'"'; 
  return new Promise(function(resolve, reject) {  
      axios.get(url)
      .then(response => {
        resolve(Object.entries(response.data).length);
      })
      .catch(e => {
        reject(e);           
      })  
  });
}

function GetOwnHikes(uid){
    var url= 'https://csavar-go.firebaseio.com/ggHike.json?orderBy="creatuser"&equalTo="'+uid+'"'; 
    return new Promise(function(resolve, reject) {  
        axios.get(url)
        .then(response => {            
          resolve(response.data);
        })
        .catch(e => {
          reject(e);           
        })  
    });
}

function GetFavoriteList(uid){
    var url= 'https://csavar-go.firebaseio.com/ggCertify.json?orderBy="userId"&equalTo="'+uid+'"'; 
    return new Promise(function(resolve, reject) {  
        axios.get(url)
        .then(response => {            
          resolve(response.data);
        })
        .catch(e => {
          reject(e);           
        })  
    });
}

var toGeoJSON = require('@mapbox/togeojson');
var DOMParser = require('xmldom').DOMParser;
function GetTrack2(trackUrl){
  return new Promise(function(resolve, reject) {  
    axios.get(trackUrl).then(resp => {  
      var gpx = new DOMParser().parseFromString(resp.data);              
      resolve(toGeoJSON.gpx(gpx));
    }).catch(e => {
      reject(e);           
    })  

  });
}

function GetFileLink(fileId,type){
  var url=null;
  console.log('fileId:',fileId);
  console.log('type:',type);
  if (type=='gpx') url='https://firebasestorage.googleapis.com/v0/b/csavar-go.appspot.com/o/track%2F'+fileId+'.gpx';
  if (type=='data') url='https://firebasestorage.googleapis.com/v0/b/csavar-go.appspot.com/o/dipsablon%2F'+fileId+'.data';  
  if ((type=='png') || (type=='jpg')) url='https://firebasestorage.googleapis.com/v0/b/csavar-go.appspot.com/o/img%2F'+fileId+'.'+type;  
  if (type=='pdf') url='https://firebasestorage.googleapis.com/v0/b/csavar-go.appspot.com/o/pdf%2F'+fileId+'.pdf';
  console.log('url:',url);
  return new Promise(function(resolve, reject) {  
      axios.get(url)
      .then(response => {        
          var url2=url+'?alt=media&token='+response.data.downloadTokens;
          console.log('url2:',url2);
          resolve(url2);
      })
      .catch(e => {
        console.log(e);
        reject(e);           
      })
  });
}

function Download(id,trackUrl,name,geogo) {
    return new Promise(function(resolve, reject) {  
        var response={};
        GetPoints(id)
        .then(res => {
                response.geogo=geogo;
                response.id=id;
                response.name=name;
                response.trackUrl=geogo.trackUrl;
                response.points=res.points;
                response.markers=res.markers;  
                if (geogo.trackUrl!="") {        
                GetTrack2(geogo.trackUrl)
                .then(res => {     
                    response.track=res
                    resolve(response);
                })
                .catch(e => {
                    reject(e);           
                })
                } else {
                resolve(response);
                }
        })
        .catch(e => {
            reject(e);           
        })
    });
}

function Download2(geogo) {
  return new Promise(function(resolve, reject) {  
      var response={};
      GetPoints(geogo.id).then(res => {
        response.geogo=geogo;
        response.id=geogo.id;
        response.name=geogo.name;
        response.trackUrl=geogo.trackUrl;
        response.points=res.points;
        response.markers=res.markers;  
        if (geogo.trackUrl!="") {        
        GetTrack2(geogo.trackUrl).then(res => {     
          response.track=res
          resolve(response);
        }).catch(e => {
          reject(e);           
        })
        } else {
          resolve(response);
        }
      }).catch(e => {
          reject(e);           
      })
  });
}

function DeleteFile(hike,file,index){
  var ref=null;
  if (file.type=='gpx')  ref = Firebase.storage().ref('/track/' + file.id + '.gpx');
  if ((file.type=='jpg') || (file.type=='png')) ref = Firebase.storage().ref('/img/' + file.id + '.' + file.type);  
  if (file.type=='pdf') ref = Firebase.storage().ref('/pdf/' + file.id + '.pdf');
  return new Promise(function(resolve, reject) { 
    ref.delete().then(function() {
      if (file.type=='gpx') hike.track='';
      if ((file.type=='jpg') || (file.type=='png')) hike.img='';
      hike.files.splice(index,1);      
      UpdateHike(hike).then(res=>{
        resolve(hike);
      }).catch(err=>{                    
        reject(err);
      });
    }).catch(function(error) {
      reject(error);
    });
  });
}

function DeleteHike(hikeId){     
  return new Promise(function(resolve, reject) { 
    GetPoints(hikeId)
    .then(res => {
        var updates = {};
        for (var p in res.points) {
            updates['/ggPoint/' + res.points[p].id] = null;        
        } 
        updates['/ggHike/' + hikeId] = null; 
        Firebase.database().ref().update(updates).then(res=>{
          resolve(true);
        }).catch(e => {
          reject(e);           
        })         
    })
    .catch(e => {
        reject(e);           
    })
  })
}

function GetDipSablonUrl(hid){  
  var url= 'https://csavar-go.firebaseio.com/ggHike/'+hid+'/dipSablon.json';
  return new Promise(function(resolve, reject) {  
      axios.get(url)
      .then(response => {    
        resolve(response.data);
      })
      .catch(e => {
        reject(e);           
      })  
  });
}

function GetDiploma(id){
  var dipUrl="https://firebasestorage.googleapis.com/v0/b/csavar-go.appspot.com/o/dipsablon%2FDefault_Sablon.data?alt=media&token=a3d3cc9e-158a-4032-900a-f9fb412cc4ed";
  return new Promise(function(resolve, reject) { 
    GetDipSablonUrl(id).then(r=>{
      if (r!="") dipUrl=r;
        axios.get(dipUrl).then(resp => {  
        resolve(resp.data);
      }).catch(e => {
          reject(e);           
      })  
    }).catch(e=>{
        reject(e);
    })
  });
}

function UpdateUserAddress(data,uid){
  var updates = {};  
  updates['/ggUser/' +uid+'/address'] = data;
  return new Promise(function(resolve, reject) { 
      Firebase.database().ref().update(updates).then(res=>{
        resolve(true);
      }).catch(e => {
        reject(e);           
      }) 
      
  })
}	

function IncrementCounter(counter){
  var ref = Firebase.database().ref('ggCounter');
  return new Promise(function(resolve, reject) {
      ref.child(counter).transaction(function(currentValue) {
          return (currentValue||0) + 1
      }, function(err, committed, ss) {
          if( err ) {
              reject(err);
          }
          else if( committed ) {
              resolve(ss.val());
          }
      });    
  });
}

function UpdateEntry2(entry,cid){
  var updates = {};  
  updates['/ggEntry/' + entry.id + '/certifyId'] = cid;
  return new Promise(function(resolve, reject) { 
      Firebase.database().ref().update(updates).then(res=>{
        resolve(true);
      }).catch(e => {
        reject(e);           
      }) 
  })
}

function UpdateEntry(entry){
  var updates = {};  
  updates['/ggEntry/' + entry.id] = entry;
  return new Promise(function(resolve, reject) { 
      Firebase.database().ref().update(updates).then(res=>{
        resolve(true);
      }).catch(e => {
        reject(e);           
      }) 
  })
}

function GetUserEntries(uid){  
  return new Promise(function(resolve, reject) {  
    var ref = Firebase.database().ref('ggEntry');
    ref.orderByChild('userId')
    .equalTo(uid)
    .once('value')
    .then(function (snapshot) {
      var value = snapshot.val();
      resolve(value);
    })
    .catch((e) => {
      reject(e);
    });
  });
}  

function GetAllEntries(){  
  return new Promise(function(resolve, reject) {  
    var ref = Firebase.database().ref('ggEntry');
    ref.once('value')
    .then(function (snapshot) {
      var value = snapshot.val();
      resolve(value);
    })
    .catch((e) => {
      reject(e);
    });
  });
}  

function GetUserCertify(cid,points){
  var url= 'https://csavar-go.firebaseio.com/ggCertify/'+cid+'.json'; 
  return new Promise(function(resolve, reject) {        
      axios.get(url)
      .then(r => { 
          var data=r.data;
          var certTable=[];
          var sumDist=0;
          for (var i in points) {
              var cRow={}
              cRow.name=points[i].name;
              if (data.points[points[i].id]>0) {
                  sumDist+=points[i].prevDist;                    
                  cRow.date=data.points[points[i].id];
                  cRow.dist=sumDist;
                  cRow.time=(cRow.date-data.startdate)/1000;
                  cRow.avgSpeed=cRow.dist/(cRow.time/3600);
              } 
              certTable.push(cRow);
          } 
          resolve([certTable,r.data]); 
      })
      .catch(e => {
        reject(e);           
      })  
  });
}

export {
    UpdateUserOther,
    SetPPandNL,
    GetPoints2,
    GetUserCertify,
    UpdateEntry2,
    AddToFavorite2,
    Download2,
    GetAllEntries,
    IsPaymentAdmin,
    IsRouteAdmin,    
    IsModeratorAdmin,    
    GetUserEntries,
    UpdateEntry,
    IncrementCounter,
    auth,
    SignUp,
    SignIn,
    SignOut,
    GetGeogo,
    GetGeogoList,
    GetPoints,
    GetTrack2,
    Download,
    GetFavoriteList,
    UpdateCertify,
    PasswordReset,
    GetOwnHikes,
    UpdateHike,
    UpdatePoints,
    DeleteFile,
    DeletePoint,
    GetHikeCertifyesCount,
    DeleteHike,
    UpdateUser,
    GetUserData,
    GetFileLink,
    updateProfile,
    updatePwd,
    GetDiploma,
    GetCertifyByDate,
    GetCertifyByStatus,
    GetCertifyByRouteId,    
    GetAllGeogoToAdmin,
    UpdateUserAddress,
    UpdateComment,
    GetCommentsByRouteId,
    GetCommentsByStatus,
    DeleteComment
}